export type SettingsDrawerSubject = "entity" | "client";

export enum SettingsDrawerTab {
  InvestorProgram = "Investor program",
  EntityProgram = "Entity program",
  ClientProgram = "Client program",
}

export const TABS_BY_SUBJECT: Record<SettingsDrawerSubject, SettingsDrawerTab[]> = {
  entity: [SettingsDrawerTab.InvestorProgram, SettingsDrawerTab.EntityProgram],
  client: [SettingsDrawerTab.ClientProgram],
};

/** The clicked grid row (entities/clients slice), plus the selected client context. */
export type SettingsDrawerRow = {
  /** Entity db id (the slice returns plain db ids). */
  id: string;
  /** Arena db id of the client selected in the grid's client search. */
  arenaId: string;
  name: string;
  arenaName?: string;
  complianceProgram?: string;
  complianceEnabled?: boolean;
  isInvestorDiligenceEnabled?: boolean;
  entityProgram?: string;
  fatcaCrsEnabled?: boolean;
  /** Client subject only. */
  clientProgram?: string | null;
};

export type SettingsDrawerTabProps = {
  row: SettingsDrawerRow;
  /** Tabs report form dirtiness so the shell can guard close with Exit-and-discard. */
  onDirtyChange: (dirty: boolean) => void;
  /** Called after a successful save so the shell can close. */
  onSaved: () => void;
  /** Close without saving (Cancel). */
  onCancel: () => void;
};
